console.warn('process.env', process.env);

module.exports = {
  Version: process.env.VERSION,
  AppInsightsInstrumentationKey: process.env.APP_INSIGHTS_INSTRUMENTATION_KEY,
  AppInsightsEnabled: true,
  ApiBaseUrl: localStorage.getItem('api-url') || 'https://portal.farmerangus.co.za/api',
  AppName: 'Farmer Angus Portal',
  ShortAppName: 'Portal',
  KeyCloak: {
    Url: 'https://beta-keycloak-elestio.firepuma.com',
    ClientId: 'web-app',
    Realm: 'farmer-angus-portal',
  },
  MapQuest: {
    ApiKey: 'lYrP4vF3Uk5zgTiGGuEzQGwGIVDGuy24', //TODO get own key, this is from the demo
  },
}



// WEBPACK FOOTER //
// ./src/config.js